module.exports = __webpack_public_path__ + "src/assets/images/add_icon.aa5312076e9ce1476fc9043a42670c78.png";